import React from "react";
import InstagramIcon from '../../components/Icons/Instagram';
import PhotoAlbum from '../../components/PhotoAlbum/PhotoAlbum';
import VideoSource from '../../components/Video/VideoSource';
import PageHeader, { PageParagraph } from '../../components/Headers/Pageheaders';
import hairphotos from './hair';
import videos from './videos';
import './styles.css';

export default function Gallery(props) {
  const galleryType = props.location.hash.replace('#','').toLowerCase();
  const PageDescription = 'For more please follow on Instagram';
  return (
    <>
      <section>
        <PageHeader title='Gallery' />
        <PageParagraph text={PageDescription} endIcon={<InstagramIcon />} />        
        <div className="container-fluid">
            {(galleryType === 'hair') &&
              <div className="d-flex flex-wrap justify-content-center">
                <PhotoAlbum
                  layout="masonry"
                  photos={hairphotos}
                />
              </div>
            }
            {(galleryType === 'reels') &&
              <div className="d-flex flex-wrap justify-content-center video-source">
                {videos.map((video, index) => (
                  <VideoSource
                    src={video.src}
                    autoPlay={false}
                    loop="loop"
                    controls="1"
                    key={index}
                  />
                ))}
              </div>         
            }
        </div>
        <div style={{ marginBottom: '10px' }} />
      </section>
    </>
  );
}
